<section
    class="story-behind-edito editorial-item"
    i18n-aria-label="@@hermes.accessibility.editorial-content"
    aria-label="Editorial content">
    <div class="editorial-item-body">
        @if (edito.contentTitle) {
        <div class="editorial-content" [innerHTML]="edito.contentTitle"> </div>
        } @if (edito.content) {
        <div class="editorial-content" [innerHTML]="edito.content"> </div>
        }
    </div>

    <div class="editorial-media">
        <div class="entity entity-hermes-media hermes-media-hermes-media">
            @if (edito.videoUrl) {
            <h-video
                [mediaType]="edito.mediaType"
                [posterUrl]="edito.desktopImage || edito.mobileImage"
                [videoName]="edito.title"
                [alwaysShowControls]="edito.alwaysShowControls"
                [videoLoopMuteAutoplay]="edito.videoLoopMuteAutoplay"
                [videoUrl]="edito.videoUrl"
                [videoRatio]="'16-9'">
            </h-video>
            } @else { @if (edito.desktopImage || edito.mobileImage) {
            <h-image-resizer
                [mediaType]="'snackable_video'"
                [desktopUrl]="edito.desktopImage"
                [desktopAlt]="edito.imageAlt"
                [pictureCssClass]="'media-wrap'"
                [mobileUrl]="edito.mobileImage">
            </h-image-resizer>
            } } @if (edito.desktopImage && edito.imageRetouched) {
            <div class="media-caption">
                <div class="image-retouched">
                    <span i18n="@@hermes.image_retouched">Retouched</span>
                </div>
            </div>
            }
        </div>
    </div>
</section>
